import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { User } from 'src/app/models/user';
import { BadgedAvatarOrIconComponent } from 'src/app/standalones/components/badged-avatar-or-icon/badged-avatar-or-icon.component';
import { IconConfig } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { UiModule } from 'src/app/ui/ui.module';

type TooltipUser = User & { altName?: string; showAvatar?: boolean; showBadge?: boolean };

@Component({
  selector: 'app-space-users-tooltip-content',
  templateUrl: './space-users-tooltip-content.component.html',
  styleUrls: ['./space-users-tooltip-content.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, TranslateModule, UiModule, BadgedAvatarOrIconComponent],
})
export class SpaceUsersTooltipContentComponent implements OnChanges {
  @Input() users: TooltipUser[] = [];
  @Input() left = 0;
  @Input() top = 0;
  @Input() classes = '';
  @Input() defaultNumberOfUsers = 4;
  @Input() title = '';
  @Input() useIconBadgedAvatarsComponent = false;
  @Input() iconConfig?: IconConfig;
  showMoreUsers = false;

  ngOnChanges() {
    this.users = this.users ?? [];
  }

  reset() {
    this.showMoreUsers = false;
  }

  /** Number of user tiles that should show for in call users */
  numberOfUsersToShow() {
    return this.numberOfUsersCondition() ? this.defaultNumberOfUsers : this.users.length;
  }
  numberOfUsersCondition() {
    return this.users?.length > this.defaultNumberOfUsers && !this.showMoreUsers;
  }
}
